import { delay, dictApi, } from '@/apis'

const user = {
  namespaced: true,
  state: {
    loadings: {}
  },
  mutations: {
    pushLoadings(state, loadingKey) {
      if (!state.loadings[loadingKey]) {
        state.loadings[loadingKey] = 0
      }
      state.loadings[loadingKey]++
    },
    popLoadings(state, loadingKey) {
      state.loadings[loadingKey]--
    },
  },
  actions: {
  },
  getters: {
    loadings: state => state.loadings,
  }
}

export default user